import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Spinner } from 'reactstrap';

import './App.scss';
import Api from './services/api';

const TelaInicial = React.lazy(() => import('./views/Main/TelaInicial'));
const Acesso = React.lazy(() => import('./views/Main/Acesso'));

const AdminMenu = React.lazy(() => import('./views/Menus/AdminMenu'));
const ClientMenu = React.lazy(() => import('./views/Menus/ClientMenu'));

class App extends Component {
  state = {
    carregandoValidar: false,
    erroValidar: '',

    vendedores: [],
    clientes: [],
    estados: [],
    cidades: [],
    pracas: [],
    ramosAtividade: [],
    planosPagamento: [],
    locaisEntrega: [],
   
    documentos: [],

    cidadesEndComercial: [],
    cidadesEndEntrega: [],
    cidadesEndCobranca: [],

    carregandoClientes: true,
    carregandoLocalEntrega: true,

    

    carregandoVendedores: true,
    carregandoEstados: true,
    carregandoEndComercialCidade: true,
    carregandoEndEntregaCidade: true,
    carregandoEndCobrancaCidade: true,
    carregandoEndComercialCodPraca: true,
    carregandoRamosAtividade: true,
    carregandoPracas: true,
    carregandoPlanosPagamento: true,
    carregandoLocaisEntrega: true,

    carregandoDocumentos: true,

    parametros: [],
    opcoesParametros: [],
    carregandoParametros: true,
    carregandoOpcoesParametros: true,

    erroEntrar: '',
    erroLocalEntrega: '',
    
  };

  carregandoCampo = () => (
    <Spinner style={{ width: '1rem', height: '1rem' }} type="grow" />
  );

  carregandoTela = () => (
    <Spinner style={{ width: '1rem', height: '1rem' }} type="grow" />
  );

  buscarNovosClientes = async () => {
    await this.setState({ carregandoClientes: true });
    try {
      const response = await Api.get('/api/clientenovo');
      await this.setState({
        carregandoClientes: false,
        clientes: response.data.result
      });
    } catch (e) {
      console.log(e.response);
      if (e.response.data.message) {
        await this.setState({
          carregandoClientes: false,
          errorClientes: e.response.data.message
        });
      } else {
        await this.setState({
          carregandoClientes: false,
          errorClientes: 'Erro ao buscar clientes novos!'
        });
      }
    }
  };

  buscarEstados = async () => {
    try {
      await this.setState({ carregandoEstados: true });
      const response = await Api.get('/api/estado');
      await this.setState({
        carregandoEstados: false,
        estados: response.data.result
      });
    } catch (e) {
      console.log(e.response);
      if (
        e.response.status === 406 &&
        e.response.statusText === 'Not Acceptable'
      ) {
        if (!this.state.erroEntrar) {
          await this.setState({
            carregandoEstados: false,
            erroEntrar: 'Not Acceptable'
          });
        }
      } else if (e.response.status === 500) {
        await this.setState({
          carregandoEstados: false,
          erroEntrar: 'Not Acceptable'
        });
      } else {
        await this.setState({ carregandoEstados: false });
      }
      //alert('Erro ao buscar estados!')
    }
  };

  buscarDocumentos = async (codCliente) => {

    await this.setState({ carregandoDocumentos: true });
    const response = await Api.get(`/api/cadastro/docs/list/?codCliente=${codCliente}`);

    let docs;
    if (response.status === 200 && response.data.files.length) {
      await this.setState({
        carregandoDocumentos: false,
        documentos: response.data.files
      });
      docs = response.data.files;
    } else {
      await this.setState({
        carregandoDocumentos: false,
        documentos: ''
      });
    }

    return docs;

  };

  setCarregandoCidades = async (endereco, carregando) => {
    
    switch (endereco) {
      case 'comercial':
        await this.setState({ carregandoEndComercialCidade: carregando });
        break;
      case 'cobranca':
        await this.setState({ carregandoEndCobrancaCidade: carregando });
        break;
      case 'entrega':
        await this.setState({ carregandoEndEntregaCidade: carregando });
        break;
      default:
        break;
    }
  };

  buscarCidades = async (endereco, estado) => {
    try {
      switch (endereco) {
        case 'comercial':
          await this.setState({ carregandoEndComercialCidade: true });
          break;
        case 'cobranca':
          await this.setState({ carregandoEndCobrancaCidade: true });
          break;
        case 'entrega':
          await this.setState({ carregandoEndEntregaCidade: true });
          break;
        default:
          break;
      }
      const response = await Api.get(`/api/cidade/${estado}`);
      switch (endereco) {
        case 'comercial':
          await this.setState({
            carregandoEndComercialCidade: false,
            cidadesEndComercial: response.data.result
          });
          break;
        case 'cobranca':
          await this.setState({
            carregandoEndCobrancaCidade: false,
            cidadesEndCobranca: response.data.result
          });
          break;
        case 'entrega':
          await this.setState({
            carregandoEndEntregaCidade: false,
            cidadesEndEntrega: response.data.result
          });
          break;
        default:
          break;
      }
    } catch (e) {
      switch (endereco) {
        case 'comercial':
          //alert('Erro ao carregando cidades do endereço comercial!')
          await this.setState({ carregandoEndComercialCidade: false });
          break;
        case 'cobranca':
          //alert('Erro ao carregando cidades do endereço cobrança!')
          await this.setState({ carregandoEndCobrancaCidade: false });
          break;
        case 'entrega':
          //alert('Erro ao carregando cidades do endereço entrega!')
          await this.setState({ carregandoEndEntregaCidade: false });
          break;
        default:
          break;
      }
      if (
        (e.response.status === 406 &&
          e.response.statusText === 'Not Acceptable') ||
        e.response.status === 500
      ) {
        await this.setState({ erroEntrar: 'Not Acceptable' });
      }
    }
  };

  buscarVendedores = async () => {
    try {
      await this.setState({ carregandoVendedores: true });
      const response = await Api.get('/api/vendedor');
      await this.setState({
        carregandoVendedores: false,
        vendedores: response.data.result
      });
    } catch (e) {
      if (e.response.status === 500) {
      }
      console.log(e.response);
      if (
        e.response.status === 406 &&
        e.response.statusText === 'Not Acceptable'
      ) {
        await this.setState({
          carregandoVendedores: false,
          erroEntrar: 'Not Acceptable'
        });
      } else if (e.response.status === 500) {
        await this.setState({
          carregandoVendedores: false,
          erroEntrar: 'Not Acceptable'
        });
      }
      //alert('Erro ao buscar vendedores!')
    }
  };

  buscarPracas = async () => {
    try {
      await this.setState({ carregandoPracas: true });
      const response = await Api.get('/api/praca');
      await this.setState({
        carregandoPracas: false,
        pracas: response.data.result
      });
    } catch (e) {
      if (
        e.response.status === 406 &&
        e.response.statusText === 'Not Acceptable'
      ) {
        await this.setState({
          carregandoPracas: false,
          erroEntrar: 'Not Acceptable'
        });
      } else if (e.response.status === 500) {
        await this.setState({
          carregandoPracas: false,
          erroEntrar: 'Not Acceptable'
        });
      }
      //alert('Erro ao buscar praças!')
    }
  };

  buscarRamosAtividade = async () => {
    try {
      await this.setState({ carregandoRamosAtividade: true });
      const response = await Api.get('/api/ramoatividade');
      await this.setState({
        carregandoRamosAtividade: false,
        ramosAtividade: response.data.result
      });
    } catch (e) {
      if (
        e.response.status === 406 &&
        e.response.statusText === 'Not Acceptable'
      ) {
        await this.setState({
          carregandoRamosAtividade: false,
          erroEntrar: 'Not Acceptable'
        });
      } else if (e.response.status === 500) {
        await this.setState({
          carregandoRamosAtividade: false,
          erroEntrar: 'Not Acceptable'
        });
      }
      //alert('Erro ao buscar Ramos de Atividades!')
    }
  };

  buscarPlanosPagamento = async () => {
    try {
      await this.setState({ carregandoPlanosPagamento: true });
      const response = await Api.get('/api/planopagamento');
      await this.setState({
        carregandoPlanosPagamento: false,
        planosPagamento: response.data.result
      });
    } catch (e) {
      if (
        e.response.status === 406 &&
        e.response.statusText === 'Not Acceptable'
      ) {
        await this.setState({
          carregandoRamosAtividade: false,
          erroEntrar: 'Not Acceptable'
        });
      } else if (e.response.status === 500) {
        await this.setState({
          carregandoRamosAtividade: false,
          erroEntrar: 'Not Acceptable'
        });
      }
    }
  };

  buscarLocalEntrega = async (e, cliCodigo) => {
    if (e) {
      //e.preventDefault();
    }

    await this.setState({
      carregandoLocaisEntrega: true,
      erroLocalEntrega: ''
    });
    try {
      const response = await Api.get(
        `/api/localentrega?clicodigo=${cliCodigo}`
      );
      await this.setState({
        carregandoLocaisEntrega: false,
        locaisEntrega: response.data.result
      });
    } catch (e) {
      console.log(e.response);
      await this.setState({
        carregandoLocaisEntrega: false,
        erroLocalEntrega: 'Erro ao buscar locais de entrega!'
      });
    }
  };
  
  limparErroLogin = async () => {
    await this.setState({ erroEntrar: '' });
  };

  buscarOpcoesParametros = async () => {
    ////console.log('buscarOpcoesParametros()');
    await this.setState({
      carregandoOpcoesParametros: true,
    });
    try {
      const response = await Api.get(
        `/api/parametros/opcoes`
      );
      let opcoes = [];
      if (response.status === 200) {
        opcoes = response.data;
      }
      await this.setState({
        carregandoOpcoesParametros: false,
        opcoesParametros: opcoes
      });
    } catch (e) {
      console.log(e.response);
      await this.setState({
        carregandoOpcoesParametros: false,
        //erroLocalEntrega: 'Erro ao buscar locais de entrega!'
      });
    }
  };

  buscarParametros = async () => {
    //console.log('Buscando parâmetros salvos');
    
    ////console.log('buscarParametros()');
    await this.setState({
      carregandoParametros: true,
    });

    try {
      const response = await Api.get(
        `/api/parametros/list`
      );
      console.log(response);
      let params = [];
      if (response.status === 200) {
        params = response.data;
      }
      await this.setState({
        carregandoParametros: false,
        parametros: params
      });
    } catch (e) {
      console.log(e.response);
      await this.setState({
        carregandoParametros: false,
      });
    }
  }

  render() {
    return (
      <BrowserRouter>
        <React.Suspense fallback={this.carregandoTela()}>
          <Switch>
            <Route
              exact
              path="/acessar"
              name="Acessar"
              render={props => (
                <Acesso {...props} limparErroLogin={this.limparErroLogin} />
              )}
            />
            <Route
              exact
              path="/cliente"
              name="Menu Cliente"
              render={props => (
                <ClientMenu
                  {...props}
                  erroEntrar={this.state.erroEntrar}
                  carregandoTela={this.carregandoTela}
                  carregandoCampo={this.carregandoCampo}
                  vendedores={this.state.vendedores}
                  estados={this.state.estados}
                  cidades={this.state.cidades}
                  pracas={this.state.pracas}
                  ramosAtividade={this.state.ramosAtividade}
                  planosPagamento={this.state.planosPagamento}
                  cidadesEndComercial={this.state.cidadesEndComercial}
                  cidadesEndEntrega={this.state.cidadesEndEntrega}
                  cidadesEndCobranca={this.state.cidadesEndCobranca}
                  carregandoVendedores={this.state.carregandoVendedores}
                  carregandoEstados={this.state.carregandoEstados}
                  carregandoEndComercialCidade={this.state.carregandoEndComercialCidade}
                  carregandoEndEntregaCidade={this.state.carregandoEndEntregaCidade}
                  carregandoEndCobrancaCidade={this.state.carregandoEndCobrancaCidade}
                  carregandoEndComercialCodPraca={this.state.carregandoEndComercialCodPraca}
                  carregandoRamosAtividade={this.state.carregandoRamosAtividade}
                  carregandoPracas={this.state.carregandoPracas}
                  carregandoPlanosPagamento={this.state.carregandoPlanosPagamento}
                  buscarNovosClientes={this.buscarNovosClientes}
                  buscarEstados={this.buscarEstados}
                  buscarCidades={this.buscarCidades}
                  setCarregandoCidades={this.setCarregandoCidades}
                  buscarVendedores={this.buscarVendedores}
                  buscarPracas={this.buscarPracas}
                  buscarRamosAtividade={this.buscarRamosAtividade}
                  buscarPlanosPagamento={this.buscarPlanosPagamento}

                  documentos={this.state.documentos}
                  buscarDocumentos={this.buscarDocumentos}
                  carregandoDocumentos={this.state.carregandoDocumentos}
                />
              )}
            />
            <Route
              path="/admin"
              name="Menu Administrador"
              render={props => (
                <AdminMenu
                  {...props}
                  erroEntrar={this.state.erroEntrar}
                  errorClientes={this.state.errorClientes}
                  limparErroLogin={this.limparErroLogin}
                  carregandoTela={this.carregandoTela}
                  carregandoCampo={this.carregandoCampo}
                  clientes={this.state.clientes}
                  vendedores={this.state.vendedores}
                  estados={this.state.estados}
                  cidades={this.state.cidades}
                  pracas={this.state.pracas}
                  ramosAtividade={this.state.ramosAtividade}
                  planosPagamento={this.state.planosPagamento}
                  locaisEntrega={this.state.locaisEntrega}
                  cidadesEndComercial={this.state.cidadesEndComercial}
                  cidadesEndEntrega={this.state.cidadesEndEntrega}
                  cidadesEndCobranca={this.state.cidadesEndCobranca}
                  carregandoClientes={this.state.carregandoClientes}
                  carregandoVendedores={this.state.carregandoVendedores}
                  carregandoEstados={this.state.carregandoEstados}
                  carregandoEndComercialCidade={
                    this.state.carregandoEndComercialCidade
                  }
                  carregandoEndEntregaCidade={
                    this.state.carregandoEndEntregaCidade
                  }
                  carregandoEndCobrancaCidade={
                    this.state.carregandoEndCobrancaCidade
                  }
                  carregandoEndComercialCodPraca={
                    this.state.carregandoEndComercialCodPraca
                  }
                  carregandoRamosAtividade={this.state.carregandoRamosAtividade}
                  carregandoPracas={this.state.carregandoPracas}
                  carregandoPlanosPagamento={
                    this.state.carregandoPlanosPagamento
                  }
                  carregandoLocaisEntrega={this.state.carregandoLocaisEntrega}
                  buscarNovosClientes={this.buscarNovosClientes}
                  buscarEstados={this.buscarEstados}
                  buscarCidades={this.buscarCidades}
                  setCarregandoCidades={this.setCarregandoCidades}
                  buscarVendedores={this.buscarVendedores}
                  buscarPracas={this.buscarPracas}
                  buscarRamosAtividade={this.buscarRamosAtividade}
                  buscarPlanosPagamento={this.buscarPlanosPagamento}
                  buscarLocalEntrega={this.buscarLocalEntrega}

                  documentos={this.state.documentos}
                  buscarDocumentos={this.buscarDocumentos}
                  carregandoDocumentos={this.state.carregandoDocumentos}

                  buscarOpcoesParametros={this.buscarOpcoesParametros}
                  buscarParametros={this.buscarParametros}
                  parametros={this.state.parametros}
                  opcoesParametros={this.state.opcoesParametros}
                  carregandoOpcoesParametros={this.state.carregandoOpcoesParametros}
                  carregandoParametros={this.state.carregandoParametros}
                  
                />
              )}
            />
            <Route
              exact
              path="/"
              name="Bem vindo!"
              render={props => <TelaInicial {...props} />}
            />
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
